import React from 'react'
import styled from 'styled-components'

const StatValue = styled.div`
  width: auto;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  ${({ leftPosition, value, theme }) => ({
    color: `${value ? theme.colors.grey : theme.colors.white}`,
    left: `${value ? leftPosition : '50'}%`,
  })};
`
const StyledBar = styled.div`
  display: block;
  height: 20px;
  width: calc(100% - 70px);
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  &:after {
    content: '';
    display: block;
    width: ${({ value }) => `${value}%`};
    min-width: ${({ value }) => (value ? `${value > 5 ? value : 5}%` : 0)};
    height: 100%;
    background-color: ${({ theme }) => theme.colors.teal};
    z-index: 1;
    background-size: 50px 50px;
    border-top-right-radius: ${({ theme }) => theme.borderRadius}px;
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius}px;
    border-top-left-radius: ${({ theme }) => theme.borderRadius}px;
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius}px;
  }
`
const StatBar = ({ value }) => {
  const leftPosition = value > 5 ? parseInt(value, 10) / 2 : 2.5
  return (
    <StyledBar value={value}>
      <StatValue leftPosition={leftPosition} value={value}>
        {value || '??'}
      </StatValue>
    </StyledBar>
  )
}

export default StatBar
